export class DropdownNav {
  burgerAdded = false;

  constructor() {
    this.burgerMenu();
  }

  dropdownBackground(element) {
    let dropdown = $(element).siblings('.dropdown');
    let offsetHeight = dropdown.outerHeight();
    $('.header-menu--background').css({
      transform: 'scaleY(' + offsetHeight + ')',
    });
  }

  dropdownIndicator(element) {
    let offsetWidth = element.offsetWidth;
    let offsetX = element.offsetLeft + offsetWidth / 2;
    $('.header-menu--indicator').css({
      transform: 'translateX(' + offsetX + 'px) scaleX(' + offsetWidth + ')',
    });
  }

  init(context, mql) {
    const $dropdowns = $('.header-menu--main-menu', context);
    if ($dropdowns.length) {
      this.setup(this, mql);
    }
  }

  setup(behavior, mql) {
    $('.header-menu--main-menu .level-1 .has-children').each(function () {
      $(this).attr('aria-haspopup', true).attr('aria-expanded', false);
    });
    if (mql.matches) {
      $('.header-menu--main-menu .level-1 .has-children').off();
      $('.header-menu--main-menu .level-1').addClass('inactive');

      $('.header-menu--main-menu .level-1 .has-children').on(
        'click keyup',
        function (e) {
          e.preventDefault();
          if (e.type == 'keyup' && e.keyCode != 13) {
            return;
          } else if (e.type == 'click') {
            var x = e.x || e.clientX;
            var y = e.y || e.clientY;
            if (!x && !y) {
              return false;
            }
          }
          let dropdownId = $(this).parent().attr('data-dropdown-id');
          let openId = $('.header-menu--main-menu .level-1.open').attr(
            'data-dropdown-id'
          );
          if (dropdownId == openId) {
            $('.header-menu--main-menu .level-1.open .has-children').attr(
              'aria-expanded',
              false
            );
            var $currentNav = $(
              '.header-menu--main-menu .level-1.open'
            ).removeClass('open');
            $currentNav.one('transitionend', function (e) {
              $currentNav.addClass('inactive');
            });
            $('.header-menu--indicator, .header-menu--background').removeClass(
              'active'
            );
            return;
          } else {
            var $search = $('.header-menu--search');
            if ($search.hasClass('open')) {
              $search.removeClass('open');
              let $searchContent = $('.header-menu--search--content');
              $searchContent.one('transitionend', function (e) {
                $searchContent.addClass('inactive');
              });
              $('.header-menu--search--background').removeClass('active');
            }

            var $currentNav = $(
              '.level-1[data-dropdown-id="' + openId + '"]'
            ).removeClass('open');
            $('.level-1[data-dropdown-id="' + openId + '"] .has-children').attr(
              'aria-expanded',
              false
            );
            $currentNav.one('transitionend', function (e) {
              $currentNav.addClass('inactive');
            });
          }
          behavior.dropdownBackground(this);
          behavior.dropdownIndicator(this);
          $(
            '.header-menu--main-menu .level-1[data-dropdown-id="' +
              dropdownId +
              '"]'
          )
            .addClass('open')
            .removeClass('inactive');
          $(
            '.header-menu--main-menu .level-1[data-dropdown-id="' +
              dropdownId +
              '"] .has-children'
          ).attr('aria-expanded', true);
          $('.header-menu--indicator, .header-menu--background').addClass(
            'active'
          );
        }
      );

      $('.main').on('click', function () {
        $('.header-menu--main-menu .level-1.open .has-children').attr(
          'aria-expanded',
          false
        );
        var $currentNav = $(
          '.header-menu--main-menu .level-1.open'
        ).removeClass('open');
        $currentNav.one('transitionend', function (e) {
          $currentNav.addClass('inactive');
        });
        $('.header-menu--indicator, .header-menu--background').removeClass(
          'active'
        );
      });
    } else {
      $('.header-menu--main-menu .level-1 .has-children').off();
      $('.header-menu--main-menu .level-1').removeClass('inactive');
      $('.header-menu--main-menu .level-1 .dropdown').addClass('inactive');
      $('.header-menu--main-menu .level-1 .has-children').on(
        'click keyup',
        function (e) {
          e.preventDefault();
          if (e.type == 'keyup' && e.keyCode != 13) {
            return;
          } else if (e.type == 'click') {
            var x = e.x || e.clientX;
            var y = e.y || e.clientY;
            if (!x && !y) {
              return false;
            }
          }
          $(this).parent().toggleClass('open');
          let dropdown = $(this).siblings('.dropdown');
          if ($(this).parent().hasClass('open')) {
            $(this).attr('aria-expanded', true);
            dropdown.removeClass('inactive');
            /* istanbul ignore next - No need to test gsap */
            gsap.to(dropdown, {
              duration: 1,
              ease: 'power4.out',
              height: 'auto',
              onComplete: function () {
                dropdown.removeClass('inactive');
              },
            });
          } else {
            $(this).attr('aria-expanded', false);
            /* istanbul ignore next - No need to test gsap */
            gsap.to(dropdown, {
              duration: 0.5,
              ease: 'power4.out',
              height: 0,
              onComplete: function () {
                dropdown.addClass('inactive');
              },
            });
          }
        }
      );
    }
  }

  burgerMenu() {
    if (this.burgerAdded) return;
    var $mobileDropdown = $('.header-menu--mobile--dropdown');
    $mobileDropdown.addClass('inactive');
    $('.header-menu--mobile--toggle').on('click', function (e) {
      e.preventDefault();

      const distanceToTop = $mobileDropdown[0].getBoundingClientRect().top;
      $mobileDropdown.css('height', `calc(100dvh - ${distanceToTop}px`);
      $(this).parent().toggleClass('open');
      if ($(this).parent().hasClass('open')) {
        $('body').css({ overflow: 'hidden' });
        $mobileDropdown.one('transitionend', function (e) {
          $mobileDropdown.removeClass('inactive');
        });
      } else {
        $('body').css({ overflow: 'auto' });
        $mobileDropdown.one('transitionend', function (e) {
          $mobileDropdown.addClass('inactive');
        });
      }

      // Close search if open.
      const $searchContent = $('.header-menu--search--content');
      if ($searchContent.length && !$searchContent.hasClass('inactive')) {
        $('.header-menu--search.open').removeClass('open');
        $searchContent.addClass('inactive');
        $('.header-menu--search--background').removeClass('active');
      }
    });
    this.burgerAdded = true;
  }
}
